import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSagittarius = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27.3334 8.66659L7.33337 28.6666M20.6667 23.3333L12.6667 15.3333M28.6667 17.9999V7.33325H18",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSagittarius;
